<template>
  <EditorAttributionContainer>
    <a
      :href="props.attribution.sourceUrl"
      class="text-xs w-full text-white font-semi-bold cursor-pointer text-decoration-none flex gap-1 items-center justify-center"
      style="z-index: 100"
      target="_blank"
    >
      {{
        I18n.t("image.background_attribution", {
          author: props.attribution.photographer,
        })
      }}
      <OpenInNewIcon class="w-4 h-4" />
    </a>
  </EditorAttributionContainer>
</template>
<script setup lang="ts">
import { OpenInNewIcon } from "prism";
import EditorAttributionContainer from "@/components/prism/editor_attribution_container.vue";
import { inject } from "vue";

const I18n = inject("I18n", window.I18n);

interface BackgroundAttributionProps {
  attribution: {
    photographer: string;
    sourceUrl: string;
  };
}
const props = defineProps<BackgroundAttributionProps>();
</script>
